import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";

import "./ClientSwiper.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const ClientSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#333" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#333" className="swiper-button-next" />
    );

    return (
        <Swiper
            navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            }}
            pagination={{ clickable: true }}
            loop
            speed={1000}
            autoplay={{ delay: 1000 }} // Set autoplay delay to 1 second
            className="swiper2 p-8 my-4"
        >
            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>"מותק עד עכשיו רק תגובות מהממות, כולם אוהבים הכי חשוב הבעל שלי אהב מאוד, תודה!"</p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>שולה
                </p>


            </SwiperSlide>
            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full  mx-auto' /> */}

                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main ' dir='rtl'>"רציתי להגיד לך ששבועיים אחרי הגבות נראות סוף הדרך!"</p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>יאנה</p>


            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full  mx-auto' /> */}

                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main ' dir='rtl'>"מחמיאים לי מלאאא, ושזה נראהה טבעי ברמותת, אהבתי ממש אין אין עלייך ❤️❤️❤️"</p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>אושר</p>


            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full  mx-auto' /> */}

                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main ' dir='rtl'>"אין דברים כאלו, תדעי שאני לא מפסיקה לקבלת מחמאות❣️"</p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>מושית מ</p>


            </SwiperSlide>




            <div className="swiper-button-prev-custom">{customPrevButton}</div>
            <div className="swiper-button-next-custom">{customNextButton}</div>
        </Swiper>
    );
}

export default ClientSwiper